import { render, staticRenderFns } from "./SubmissionTestCases.vue?vue&type=template&id=7b9b6fad&scoped=true&"
import script from "./SubmissionTestCases.vue?vue&type=script&lang=js&"
export * from "./SubmissionTestCases.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionTestCases.vue?vue&type=style&index=0&id=7b9b6fad&scoped=true&lang=css&"
import style1 from "./SubmissionTestCases.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b6fad",
  null
  
)

export default component.exports